export const stripTime = (date: Date) => date.setHours(0, 0, 0, 0);
